import { Controller } from '@hotwired/stimulus'

// Drives the billing plan history modal: one shared form switches between
// registering a new plan and editing an existing row, and quota fields stay
// disabled until a plan type is chosen.
export default class extends Controller {
  static targets = ['form', 'method', 'formTitle', 'submit', 'cancelEdit',
                    'planType', 'effectiveFrom', 'quota', 'quotaLabel', 'atendimentosQuota', 'creditReportsQuota',
                    'creditReportsBonus', 'remarketingBonus', 'baseUpdateBonus']

  connect() {
    this.createUrl = this.formTarget.action
    this.toggleQuotas()
  }

  edit(event) {
    const { url, planType, effectiveFrom, atendimentosQuota, creditReportsQuota, creditReportsBonus,
            remarketingBonus, baseUpdateBonus } = event.currentTarget.dataset
    this.formTarget.action = url
    this.methodTarget.value = 'patch'
    this.planTypeTarget.value = planType
    this.effectiveFromTarget.value = effectiveFrom
    this.atendimentosQuotaTarget.value = atendimentosQuota ?? ''
    this.creditReportsQuotaTarget.value = creditReportsQuota ?? ''
    this.creditReportsBonusTarget.value = creditReportsBonus ?? '0'
    this.remarketingBonusTarget.value = remarketingBonus ?? '0'
    this.baseUpdateBonusTarget.value = baseUpdateBonus ?? '0'
    this.formTitleTarget.textContent = 'Editar plano'
    this.submitTarget.textContent = 'Salvar alteração'
    this.cancelEditTarget.classList.remove('hidden')
    this.toggleQuotas()
  }

  resetForm() {
    this.formTarget.action = this.createUrl
    this.methodTarget.value = 'post'
    this.formTarget.reset()
    this.formTitleTarget.textContent = 'Registrar alteração'
    this.submitTarget.textContent = 'Registrar'
    this.cancelEditTarget.classList.add('hidden')
    this.toggleQuotas()
  }

  // Quota fields follow the plan type: disabled without a type, locked as
  // limitless for usage-based, and labeled per month/year for fixed/annual.
  toggleQuotas() {
    const type = this.planTypeTarget.value
    const usageBased = type === 'usage_based'
    this.quotaTargets.forEach((input) => {
      input.disabled = type === '' || usageBased
      if (usageBased) input.value = ''
      input.placeholder = usageBased ? 'Sem limites' : 'Não contratado'
    })
    this.quotaLabelTargets.forEach((label) => {
      label.textContent = `${label.dataset.base}/${type === 'annual' ? 'ano' : 'mês'}`
    })
  }
}
